import { render, staticRenderFns } from "./GogoSafe.vue?vue&type=template&id=22ac77c6&scoped=true"
var script = {}
import style0 from "./GogoSafe.vue?vue&type=style&index=0&id=22ac77c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac77c6",
  null
  
)

export default component.exports